import { forwardRef } from "react";
import { useSelector } from "react-redux";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { Trans } from "@hopper-b2b/i18n";
import {
  HotelShopSection,
  HotelsShopSelectors,
  useHotelSlot,
} from "@tenant/hotels";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./HotelRoomSelectionSection.module.scss";

interface HotelRoomSelectionSectionProps {
  title: string;
  goToNextStep: () => void;
  className?: string;
}

export const HotelRoomSelectionSection = forwardRef<
  HTMLDivElement,
  HotelRoomSelectionSectionProps
>(({ title, goToNextStep, className }, ref) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelRoomSelectionSection;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { isLoading: isRoomsLoading } = useSelector(
    HotelsShopSelectors.getRooms
  );

  const HotelSlot = useHotelSlot();

  if (isRoomsLoading) {
    return null;
  }

  return (
    <HotelShopSection
      title={title}
      className={clsx(block, className)}
      ref={ref}
    >
      <div className={cn("subtitle")}>
        <Icon className={cn("icon")} iconName={IconNameEnum.avionCoin} />
        <span className={cn("subtitle-text")}>
          <Trans
            i18nKey="core-hotels.roomSelection.subtitle"
            components={[<strong />]}
          />
        </span>
      </div>
      <HotelSlot.HotelRoomSelectionBanner />
      <HotelSlot.HotelRoomSelection goToNextStep={goToNextStep} />
    </HotelShopSection>
  );
});

HotelRoomSelectionSection.displayName = "HotelRoomSelectionSection";
